// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"213":"2fcaa3ef","298":"59cb1c64","683":"e886f860"}[chunkId] + ".chunk.css";
};